export const SET_ERRORS = 'SET_ERRORS';
